import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Printer } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { apiFetch, getLocalizedError } from "@/lib/api";

/**
 * Nút In ngay trên một dòng danh sách.
 *
 * VÌ SAO PHẢI TẢI THÊM: bản in cần đủ dòng hàng, mà danh sách chỉ mang phần
 * đầu chứng từ. Tải lúc BẤM chứ không tải sẵn cho cả trang — một trang 100
 * dòng mà tải trước là 100 lần gọi API cho một lần in.
 *
 * Trước đây phải mở chi tiết rồi mới in được; in một xấp chứng từ nghĩa là mở
 * và đóng từng cái. Đây là thao tác lặp hàng ngày nên đáng một nút.
 */
export function RowPrintButton<T>({
  path,
  print,
  label,
}: {
  /** Đường dẫn chi tiết, ví dụ `/invoices/abc`. */
  path: string;
  print: (doc: T) => void;
  /** Đọc cho trình đọc màn hình: in CÁI GÌ. */
  label: string;
}) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onClick = async () => {
    setErr(null);
    setBusy(true);
    try {
      const r = await apiFetch<{ data: T }>(path);
      print(r.data);
    } catch (e) {
      setErr(getLocalizedError(e, t, "errors.notFound"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      disabled={busy}
      onClick={(e) => {
        // Dòng danh sách thường bấm-để-mở; không chặn thì bấm In cũng điều
        // hướng sang trang chi tiết.
        e.stopPropagation();
        void onClick();
      }}
      aria-label={label}
      title={err ?? label}
    >
      <Printer className={"size-3.5" + (busy ? " animate-pulse" : "")} />
    </Button>
  );
}
